import APIRequestState from './_util/api-request';
import QS from 'querystring';

class GetWorkerPortfolioState extends APIRequestState {
  getRequest(urlId, urlParams) {
    return this.ctx.sdk.get(`/workers/${urlId}/portfolio/images?${QS.stringify(urlParams)}`);
  }
}

export default GetWorkerPortfolioState;



// WEBPACK FOOTER //
// ./spa/state/worker-portfolio.jsx